(function () {
  // Product gallery thumbnails
  document.querySelectorAll('.mtx .hero').forEach(function (h) {
    var m = h.querySelector('.mtx-main');
    h.querySelectorAll('.th').forEach(function (b) {
      b.addEventListener('click', function () {
        if (m) { m.removeAttribute('srcset'); m.src = b.dataset.src; }
        h.querySelectorAll('.th').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  });

  // Variant select updates the shown price
  document.querySelectorAll('.mtx-var').forEach(function (s) {
    s.addEventListener('change', function () {
      var o = s.selectedOptions[0], b = s.closest('.buy');
      b.querySelector('.mtx-price').textContent = o.dataset.price;
      var bp = b.querySelector('.mtx-btnp'); if (bp) bp.textContent = o.dataset.price;
      var c = b.querySelector('.mtx-cmp'); if (c) { c.textContent = o.dataset.cmp; c.hidden = !o.dataset.cmp; }
    });
  });

  // Collection sort uses Shopify's sort_by parameter
  var so = document.querySelector('.mtx-sort');
  if (so) so.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', so.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  // Shop by bike dropdown (hover handled in CSS, click for touch)
  var dd = document.querySelector('.mtx .dd');
  if (dd) {
    var db = dd.querySelector('.ddb');
    db.addEventListener('click', function (ev) { ev.stopPropagation(); db.setAttribute('aria-expanded', dd.classList.toggle('open')); });
    document.addEventListener('click', function (ev) { if (!dd.contains(ev.target)) { dd.classList.remove('open'); db.setAttribute('aria-expanded', 'false'); } });
  }

  // Search popup backed by Shopify predictive search
  var ov = document.getElementById('mtx-so'), sq = document.getElementById('mtx-sq'), sr = document.getElementById('mtx-sres');
  if (!ov) return;
  function closeS() { ov.hidden = true; }
  document.querySelectorAll('.mtx-sopen').forEach(function (a) {
    a.addEventListener('click', function (ev) { ev.preventDefault(); ov.hidden = false; sq.value = ''; sr.textContent = ''; sq.focus(); });
  });
  ov.addEventListener('click', function (ev) { if (ev.target === ov) closeS(); });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeS(); });

  var timer, seq = 0;
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
  sq.addEventListener('input', function () {
    clearTimeout(timer);
    var t = sq.value.trim();
    if (!t) { sr.textContent = ''; return; }
    timer = setTimeout(function () {
      var mine = ++seq;
      var url = sr.dataset.suggestUrl + '.json?q=' + encodeURIComponent(t) + '&resources[type]=product&resources[limit]=6';
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        if (mine !== seq) return;
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        sr.textContent = '';
        items.forEach(function (p) {
          var a = el('a', 'sr'); a.href = p.url;
          if (p.image) { var i = el('img'); i.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; i.alt = ''; a.appendChild(i); }
          a.appendChild(el('b', '', p.title));
          a.appendChild(el('span', '', p.price ? '$' + Number(p.price).toFixed(2) : ''));
          sr.appendChild(a);
        });
        var all = el('a', 'sall', items.length ? 'See all results' : 'No results found');
        all.href = sr.dataset.searchUrl + '?type=product&q=' + encodeURIComponent(t);
        sr.appendChild(all);
      }).catch(function () {});
    }, 200);
  });
})();
